import React, {PureComponent} from 'react'
import Store from 'Store'
import {inject, observer} from 'mobx-react'
import {loading} from 'elements/Loading'
import {FormStretch} from 'components'
import {FieldType, IField} from 'elements'
import {Rules, rules} from 'helpers/Validation'
import Stretch from '../Model'
import PassengerCategory from '../../PassengerCategories/Model'
import {stringify} from 'querystring'
import {Iconos} from '../../../elements/IconosApp'
import OperationLine from '../../OperationLines/Model'
import {Tax} from '../../Taxes/Model'
import StretchesFormulario from '../../../components/StretchesFormulario'

interface Props {
  store?: Store
  match: any
  stretch: Stretch
  passengerCategories: PassengerCategory[]
  operationLines: OperationLine[]
  taxes: Tax[]
}

/**
 *
 */
interface Dictionary<T> {
  [key: number]: T
}

@inject('store')
@loading<Props>(props => [
  props.store!.passengerCategories.read().then(passengerCategories => {
      // console.log('finalizado passengerCategories read')
      return {passengerCategories}
    }
  ),
  props.match.params.id
    ? props.store!.stretches
      .read(props.match.params.id)
      .then(stretch => ({stretch}))
    : undefined,
  props.store!.operationLines.read().then(operationLines => ({operationLines})),

  props.store!.taxes.read().then(taxes => ({taxes})),

])
export default class extends PureComponent<Props, object> {
  private priceFields = this.props.passengerCategories.map((item) => {
    // console.log('item', item)

    const prices = this.props.stretch? this.props.stretch.prices : []
    let esquema: Dictionary<string> = {}
    prices.forEach(priceItem => {
      esquema[priceItem.passengerCategory_id] = priceItem.price
    })

    // console.log('esquema', esquema)

    return {
      name: item.name,
      type: FieldType.Text,
      rules: rules().number(),
      size: 2,
      id: item.id,
      value: esquema[item.id]
    }
  })

  private operations = this.props.operationLines? this.props.operationLines : []
  private operationsMapeados = this.operations.map(item => {
    // console.log('item', item)
    return {
      value: String(item.id),
      name: item.name
    }
  })
  private operationsOptions = !this.props.stretch? [{value: '0', name: ''}, ...this.operationsMapeados]: this.operationsMapeados

  private taxes = this.props.taxes? this.props.taxes : []
  private taxesMapeados = this.taxes.map(item => {
    // console.log('item', item)
    return {
      value: String(item.id),
      name: item.name
    }
  })
  private taxesOptions = !this.props.stretch? [{value: '0', name: ''}, ...this.taxesMapeados] : this.taxesMapeados

  private fields = [
    {
      name: 'name',
      type: FieldType.Text,
      rules: rules()
        .string()
        .required(),
      size: 6
    },
    {
      name: 'code',
      type: FieldType.Text,
      rules: rules()
        .string()
        .required(),
      size: 4
    },
    {
      name: 'origin',
      type: FieldType.Text,
      rules: rules()
        .string(),
      size: 5
    },
    {
      name: 'destination',
      type: FieldType.Text,
      rules: rules()
        .string(),
      size: 5
    },
    {
      name: 'tax',
      column: 'tax_id',
      type: FieldType.Select,
      rules: rules()
        .number()
        .integer()
        .required(),
      options: this.taxesOptions,
      size: 2,
    },
    {
      name: 'operationline',
      column: 'operationLine_id',
      type: FieldType.Select,
      rules: rules()
        .number()
        .integer()
        .required(),
      options: this.operationsOptions,
      size: 2
    },
    {
      name: 'printPrice',
      type: FieldType.Checkbox,
      rules: rules()
        .boolean(),
      size: 2,
      defaultValue: true
    },
    {
      name: 'tramoHora',
      type: FieldType.Checkbox,
      rules: rules()
        .boolean(),
      size: 2,
      defaultValue: true
    },
    {
      name: 'hora',
      type: FieldType.Time,
      size: 2,
      defaultValue: {hours: 0, minutes: 0}
    },
    {
      name: 'hoponHopoff',
      type: FieldType.Checkbox,
      rules: rules()
        .boolean(),
      size: 2,
      defaultValue: false
    },
    {
      name: 'vuelta',
      type: FieldType.Checkbox,
      rules: rules()
        .boolean(),
      size: 1,
      defaultValue: false
    },
    {
      name: 'timeAdvance',
      type: FieldType.Number,
      rules: rules()
        .number()
        .integer(),
      defaultValue: 0,
      size: 4
    },
    {
      name: 'timeExpiration',
      column: 'timeExpiration',
      type: FieldType.Number,
      rules: rules()
        .number()
        .integer(),
      defaultValue: 0,
      size: 4
    },
    {
      name: 'timeCancel',
      type: FieldType.Number,
      rules: rules()
        .number()
        .integer(),
      defaultValue: 0,
      size: 4
    },
    {
      name: 'description',
      type: FieldType.TextArea,
      rules: rules()
        .string(),
      size: 10
    },
    {
      name: 'icon',
      type: FieldType.Icon,
      rules: rules()
        .string(),
      size: 12,
      icons: Iconos
    }
  ]

  handleTramoHora = (value: boolean) => {
    console.log('StretchesForm - handleTamoHora - value: ', value)
  }

  render() {
    /*this.prices = [...this.prices, ...[
      {name: 'Discapacitado',
        type: FieldType.Text,
        rules: rules().number(),
        size: 1
      }
      ]
    ]*/
    // console.log('this.categoryFields', this.categoryFields)
    // console.log('StretchesForm - render - this.fields', this.fields)
    const {stretch} = this.props
    if (stretch) {
      stretch.hora = {hours: stretch.hours, minutes: stretch.minutes}
    }
    // console.log('StretchesForm - render - stretchForm', stretch)
    const stretches = this.props.store!.stretches
    const {passengerCategories} = this.props
    const prices = this.props.stretch? this.props.stretch.prices: []

    // console.log('passengerCategories', passengerCategories)
    return (
      <div>
        <StretchesFormulario
          /*delete={this.props.match.params.id}*/
          loading={['post@stretch/', 'put@stretch/', 'delete@stretch/']}
          fields={this.fields}
          values={stretch}
          store={stretches}
          priceFields={this.priceFields}
          stores={this.props.store!}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Stretches/container/StretchesForm.tsx